import { render, staticRenderFns } from "./PortalSubtopicAsideWidget.vue?vue&type=template&id=287f8951&"
import script from "./PortalSubtopicAsideWidget.vue?vue&type=script&lang=ts&"
export * from "./PortalSubtopicAsideWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports